module.exports = __webpack_public_path__ + "static/logo-52e5889d12a09faeb19c955da55cefb8.png";